
import { price } from '../common-lib.service';
export class Rates  {
    rates = {};
    
    constructor() {
      this.rates = {
        INR: price,
        detectedCountry: 1
        };
    }
    
}
